module.exports = __webpack_public_path__ + "static/img/rush-over-date-card.25bb7f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw/rush-over-date-card.png
// module id = z4JM
// module chunks = 216